module.exports = __webpack_public_path__ + "img/wallet.8753b815.png";